import { SkinSize } from '../../lib/skin/getSizeSkin/generated/types';
import type { VerticalAlignAddonSize, VerticalAlignTextPreset } from '../../hooks/useVerticalAlign/types';
import type { TextPreset } from '../TextGeneric/types';

import type { HeaderLevel } from './types';

export const headerSkinSizes: Record<HeaderLevel, SkinSize> = {
    h1: '2xl',
    h2: 'xl',
    h3: 'l',
    h4: 'm',
    h5: 'xs', // xs на время, пока не перейдем в s на 14-20 DIRECT-238538
};

interface HeaderOptions {
    /**
     * Размер заголовка (без описания)
     */
    withoutCaption: VerticalAlignTextPreset;

    /**
     * Комбинированный размер текста для заголовка и описания
     */
    withCaption: VerticalAlignTextPreset;
}

export const headerStyles: Record<HeaderLevel, HeaderOptions> = {
    h1: { withoutCaption: '32-40-M', withCaption: '32-40-M + 20-28' },
    h2: { withoutCaption: '24-32-M', withCaption: '24-32-M + 16-24' },
    h3: { withoutCaption: '20-28-M', withCaption: '20-28-M + 16-24' },
    h4: { withoutCaption: '16-24-M', withCaption: '16-24-M + 16-24' },
    h5: { withoutCaption: '14-20-M', withCaption: '14-20-M + 12-16' },
};

interface HeaderAddonOptions {
    addon: VerticalAlignAddonSize;
    textAddon: TextPreset;
    textAddonPadding: '6' | '4' | '2' | '0';
}

export const headerAddonSizes: Record<HeaderLevel, HeaderAddonOptions> = {
    h1: { addon: '24', textAddon: '20-28', textAddonPadding: '6' },
    h2: { addon: '24', textAddon: '16-24', textAddonPadding: '4' },
    h3: { addon: '24', textAddon: '16-24', textAddonPadding: '2' },
    h4: { addon: '24', textAddon: '16-24', textAddonPadding: '0' },
    h5: { addon: '20', textAddon: '12-16', textAddonPadding: '2' },
};
